export default __webpack_public_path__ + "static/media/expert01.16924dc8.jpg";